import React from "react"
import { Box, Card, IconButton, Typography } from "@mui/material"
import CloudinaryImage from "../../../components/Image/CloudinaryImage"
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap"
import { COLORS } from "../../../utils"

export const sx = {
	card: {
		flex: 1,
		backgroundColor: "#FFFFFF",
		boxShadow: "none",
		minWidth: "348px",
		maxWidth:"900px",
		display: "flex",
		flexDirection: "column",
		alignSelf: "stretch"
	},
	cardContent: {
		padding: "12px 16px",
		backgroundColor: COLORS.YELLOW_100,
		display: "flex",
		flexDirection: "column",
		gap: "8px",
		borderRadius: "8px",
		zIndex: 10,
		marginTop: "-5px"
	},
	imageContainer: {
		position: "relative",
		borderTopLeftRadius: "4px",
		borderTopRightRadius: "4px",
		overflow: "hidden"
	},
	image: {
		width: "100%",
		height: "auto",
	},
	zoomButton: {
		position: "absolute",
		top: 0,
		right: 0,
		zIndex: 1000
	},
	title: {
		color: COLORS.PRODUCTION_STEPS_TEXT_GREY,
		fontSize: 16,
		lineHeight: 1.5,
		fontWeight: 500
	},
	description: {
		fontSize: 16,
		lineHeight: 1.5,
		fontWeight: 400,
		color: COLORS.BLACK800,
	},
}

const PackagingExecutionPresentation = ({ packaging, openImagePreview }) => {
	return (
		<Card sx={sx.card}>
			<Box sx={sx.imageContainer}>
				<IconButton sx={sx.zoomButton} onClick={openImagePreview} size="small">
					<ZoomOutMapIcon />
				</IconButton>
				<CloudinaryImage
					imageId={packaging?.packagingImage}
					crop="fit"
					width="100%"
					height="auto"
				/>
			</Box>
			<Box sx={sx.cardContent} className="flex1">
				<div>
					<Typography variant="body" sx={sx.title}>
						Instructions de dressage
					</Typography>
				</div>
				<div>
					<Typography variant="h6" sx={sx.description}>
						{packaging?.instructions}
					</Typography>
				</div>
			</Box>
		</Card>
	)
}

export default PackagingExecutionPresentation